import React, { useState, useEffect, useRef } from 'react';
import Tag from '../../components/ui/Tag';
import ElixirImage from '../../../public/images/tunisian-landscape.webp';
import Button from '@/components/ui/Button';
import { useNavigate } from 'react-router-dom';

const AchievementSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);
  const [imgVisible, setImgVisible] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  
  const handleDiscoverMore = () => {
    navigate('/about');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Section is in view
          }
        });
      },
      {
        threshold: 0.3, // 50% of the section must be in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current); // Observe the section
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Trigger individual animations after section is visible
  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
      setTimeout(() => setParaVisible(true), 300); // Delay para animation
      setTimeout(() => setImgVisible(true), 600); // Delay image animation
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-12">
          <h2
            className={`text-2xl md:text-4xl lg:text-4xl font-extralight text-[#000000] mb-6 text-center mt-10 md:text-center transition-all duration-1000 ${
              titleVisible
                ? 'opacity-100 translate-y-0 animate-slideUp'
                : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Discover the Heart of Elixir
          </h2>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-8">
          {/* Text Content */}
          <div className="w-full md:w-1/2 text-left px-4 md:px-0">
            <ul className="space-y-4 text-lg text-[#333]">
              <li>
                From the ancient traditions of Tunisian beekeeping to our unwavering commitment to
                quality, the Elixir story is one of passion, heritage, and a deep respect for
                nature. Learn more about our journey.
              </li>
            </ul>
            <Button
              variant="gold"
              size="large"
              onClick={handleDiscoverMore}
              className="font-semibold rounded-3xl py-3 my-6 px-5"
            >
              Discover More
            </Button>
          </div>
          {/* Image */}
          <div
            className={`w-full  md:w-1/2 transition-all duration-1000 ${
              imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <img
              src={ElixirImage}
              alt="Elixir Eucalyptus"
              className="rounded-lg h-auto max-h-[450px] w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default AchievementSection;
